import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import cn from 'classnames';
import { KPI_TYPES } from '../../constants';
import { useKpiCalculations } from '../../hooks';
import Loader from '../../partials/Loader';
import Cell from '../../partials/Cell';
import cellsStyles from '../../partials/Cells.pcss';
import styles from './Indicators.pcss';
const Indicators = ({ readings, preMealReadings, postMealReadings, daysWithReadings, daysWithoutReadings, readingsWithoutFlag = 0, className, isInProgress = false, onAddNote })=>{
    const kpiCalculations = useKpiCalculations({
        readings,
        preMealReadings,
        postMealReadings
    }, {
        daysWithReadings,
        daysWithoutReadings
    });
    useStyles(styles);
    useStyles(cellsStyles);
    if (!kpiCalculations || isInProgress) {
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.KPIs, className),
            children: /*#__PURE__*/ _jsx(Loader, {})
        });
    }
    const { readingsAverage } = kpiCalculations;
    const renderKPI = (type, value)=>/*#__PURE__*/ _jsx(Cell, {
            type: type,
            value: value,
            readingsAverage: readingsAverage,
            onAddNote: onAddNote
        });
    const renderAverage = ()=>{
        if (readingsWithoutFlag > readings.length / 2) {
            return renderKPI(KPI_TYPES.AVERAGE, readingsAverage);
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                preMealReadings.length > 0 && renderKPI(KPI_TYPES.AVERAGE_PRE_MEAL, kpiCalculations.preMealAverage),
                postMealReadings.length > 0 && renderKPI(KPI_TYPES.AVERAGE_POST_MEAL, kpiCalculations.postMealAverage)
            ]
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.KPIs, className),
        "data-testid": "kpis",
        children: [
            renderKPI(KPI_TYPES.TOTAL_READINGS, kpiCalculations.totalReadings),
            renderKPI(KPI_TYPES.AVG_READINGS, kpiCalculations.avgReadings),
            renderKPI(KPI_TYPES.DAYS_WITHOUT_READING, kpiCalculations.daysWithoutReadings),
            renderKPI(KPI_TYPES.GMI, kpiCalculations.GMI),
            renderKPI(KPI_TYPES.VERY_HIGH, kpiCalculations.criticalHighReadings),
            renderKPI(KPI_TYPES.VERY_LOW, kpiCalculations.criticalLowReadings),
            renderKPI(KPI_TYPES.STANDARD_DEVIATION, kpiCalculations.standardDeviation),
            renderAverage(),
            renderKPI(KPI_TYPES.CV, kpiCalculations.CV)
        ]
    });
};
export default Indicators;
